const ABViewDetailItemCore = require("../../core/views/ABViewDetailItemCore");
module.exports = class ABViewDetailItem extends ABViewDetailItemCore {};
